export default "__VITE_ASSET__0ed1e81f__"